import React from 'react'

export type UiPropertyField = {
  id: string
  label: string
  control: React.ReactNode
}

export type UiPropertySection = {
  title: string
  fields: UiPropertyField[]
}

type UiPropertiesPanelProps = {
  componentName: string
  sections: UiPropertySection[]
}

const UiPropertiesPanel: React.FC<UiPropertiesPanelProps> = ({
  componentName,
  sections,
}) => {
  return (
    <aside className="ui-properties">
      <header className="ui-properties__header">
        <h2 className="ui-properties__title">Properties</h2>
        <p className="ui-properties__subtitle">{componentName}</p>
      </header>

      <div className="ui-properties__body">
        {sections.map((section) => (
          <section key={section.title} className="ui-properties__section">
            <h3 className="ui-properties__section-title">{section.title}</h3>
            <div className="ui-properties__fields">
              {section.fields.map((field) => (
                <div key={field.id} className="ui-properties__field">
                  <label className="ui-properties__label" htmlFor={field.id}>
                    {field.label}
                  </label>
                  {field.control}
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </aside>
  )
}

export default UiPropertiesPanel
